import React from 'react'
import PropTypes from 'prop-types'
import { isBefore } from 'date-fns'
import { t } from 'translation'
import CloudImg from '../../assets/check.png'

const CompositionsListSongItem = ({
  clickHandler,
  image,
  subtitle,
  title,
  newUntil,
  isDownloaded,
  index,
  songsRef,
}) => (
  <li className="composition_list_item">
    <button
      className="composition_block composition_block_btn"
      ref={(btn) => (songsRef.current[index] = btn)}
      onClick={clickHandler}
    >
      <div className="composition_block_w_img song_mod">
        {isDownloaded && (
          <div className="composition_cloud_icon_w">
            <img className="composition_cloud_icon" src={CloudImg} />
          </div>
        )}
        <img className="composition_block_img" src={image} />
        {newUntil && isBefore(new Date(), new Date(newUntil)) ? (
          <div className="composition_block_new_until">{t('genre.NEW')}</div>
        ) : null}
      </div>
      <div className="composition_block_descr">
        <span className="composition_block_title default_text">{title}</span>
        {subtitle && (
          <span className="composition_block_subtitle default_text">{subtitle}</span>
        )}
      </div>
    </button>
  </li>
)

export default CompositionsListSongItem

CompositionsListSongItem.propTypes = {
  newUntil: PropTypes.string,
  clickHandler: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}
